import React from 'react';
import Riddle from '../Riddle';

const Level21 = ({progress, failure}) => {
  return (
    <Riddle prompt={"How many family members have you seen?"} correctAnswer={"12"} progress={progress} failure={failure}/>
  );
};

export default Level21;